import { ref } from 'vue'
import type { StrongsEntry } from '../types/strongs'
import { apiClient } from '../services/apiClient'

export function useStrongsDictionary() {
  const isEnabled = ref(false)
  const showPanel = ref(false)
  const showMorphology = ref(false)
  const currentEntry = ref<StrongsEntry | null>(null)
  const currentWord = ref('')
  const currentNumber = ref('')
  const currentTestament = ref<'OT' | 'NT' | 'MORPH'>('OT')
  const loading = ref(false)
  const error = ref<string | null>(null)

  const cache = new Map<string, StrongsEntry>()

  const toggleEnabled = () => {
    isEnabled.value = !isEnabled.value
    if (!isEnabled.value) {
      closePanel()
    }
  }

  const closePanel = () => {
    showPanel.value = false
    currentEntry.value = null
    currentWord.value = ''
    currentNumber.value = ''
  }

  const lookupWord = async (strongsNumber: string, testament: 'OT' | 'NT', word: string) => {
    currentNumber.value = strongsNumber
    currentTestament.value = testament
    currentWord.value = word
    showPanel.value = true
    loading.value = true
    error.value = null

    try {
      const key = `${testament}-${strongsNumber}`
      if (cache.has(key)) {
        currentEntry.value = cache.get(key)!
      } else {
        const entry = await apiClient.lookupStrongs(strongsNumber, testament)
        currentEntry.value = entry
        cache.set(key, entry)
      }
    } catch (err) {
      error.value = err instanceof Error ? err.message : 'Failed to lookup Strong\'s number'
      currentEntry.value = null
    } finally {
      loading.value = false
    }
  }

  return {
    isEnabled,
    showPanel,
    showMorphology,
    currentEntry,
    currentWord,
    currentNumber,
    currentTestament,
    loading,
    error,
    toggleEnabled,
    closePanel,
    lookupWord,
  }
}
